import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "newResourcePhone" }

import { ElMessage } from 'element-plus'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewResourcePhone',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getDept = async () => {
  let deptList = await getListData('/main/resourceAnalysis/getTop13DepartmentListByDeptSort', {})
  const deptOptions = deptList.map((item: any) => {
    return {title: item.name, value: item.id};
  })
  const deptItem = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  deptItem!.options = deptOptions
}
getDept()
const queryParam = {
  sysDate: dayjs().startOf('date').format('YYYY-MM-DD')
}
store.commit('system/changeQueyryInfo', queryParam)
const searchCb = (formdata:any) => {
  // // 检查 lastMonthSalesAmountType 或 isPhoneCommunicationFlag 是否有值（包括0）
  // if ((formdata.lastMonthSalesAmountType !== undefined && formdata.lastMonthSalesAmountType !== null && formdata.lastMonthSalesAmountType !== '') ||
  //     (formdata.firstCreatedAtSalesAmountType !== undefined && formdata.firstCreatedAtSalesAmountType !== null && formdata.firstCreatedAtSalesAmountType !== '') ||
  //     (formdata.contactDeadlineSalesAmountType !== undefined && formdata.contactDeadlineSalesAmountType !== null && formdata.contactDeadlineSalesAmountType !== '') ||
  //     (formdata.isPhoneCommunicationFlag !== undefined && formdata.isPhoneCommunicationFlag !== null && formdata.isPhoneCommunicationFlag !== '')) {
  //   // 检查 sysDate 是否为今天
  //   if (formdata.sysDate === dayjs().format('YYYY-MM-DD')) {
  //     ElMessage.warning('查询当日的新资源电话情况时，没有上个月业绩和是否电话联系数据！')
  //   }
  // }
}
const resetCb = () => {
  return queryParam
}
// 定义筛选规则
const filterRules = [
  '筛选规则：',
  '1、每天下午5点，生成当日业务员新资源情况通知',
  '2、每天早上3点半，记录昨日业务员新资源电话沟通情况',
  '3、每天早上5点半，检查通话联系截止时间是昨天的新资源是否通话联系',
  '入职3个月内的，上个月业绩小于6万；入职满3个月的，上月业绩小于10万。这些都是不达标，就会标红。'
]
const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb,searchCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      labelWidth: '150px'
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "newResourcePhone",
      pageUrl: "/dailyNewResourcePhone/queryByCondition",
      downUrl: "/dailyNewResourcePhone/download",
      downFilename: "业务员每日新资源电话沟通情况.xlsx",
      filterRules: filterRules,
      onDownBtnClick: _unref(handleDownBtnClick)
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})